// Production default. Override locally with .env.local:
//   REACT_APP_API_URL=http://localhost:8010
// See .env.local.example.
const API_URL = process.env.REACT_APP_API_URL || 'https://imole.to';

// Clear the dead credential and bounce to login. Called when the backend
// rejects our token (401) — e.g. the 14-day signed token has expired. Without
// this the app keeps a stale token and renders broken states (raw
// "Authentication required" + zeroed cards) instead of prompting a re-login.
function handleUnauthorized() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  if (window.location.pathname !== '/login') {
    window.location.assign('/login?expired=1');
  }
}

export async function authFetch(path, options = {}) {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    credentials: 'include',
    headers,
  });
  if (res.status === 401) {
    handleUnauthorized();
  }
  return res;
}

export default API_URL;
